import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Right_Double_Chevron: React.FC<Props> = ({ fill }) => {
    return (
        <Svg viewBox="0 0 24 24" fill={fill} width="12pt" height="100%">
            <Path d="M 4.036 18.017 C 3.659 18.016 3.315 17.803 3.146 17.467 C 2.899 16.975 3.096 16.377 3.586 16.127 L 11.796 12.017 L 3.586 7.907 C 2.875 7.611 2.751 6.657 3.363 6.189 C 3.689 5.94 4.134 5.916 4.486 6.127 L 14.486 11.127 C 15.171 11.478 15.219 12.439 14.573 12.857 C 14.545 12.875 14.516 12.892 14.486 12.907 L 4.486 17.907 C 4.348 17.981 4.193 18.019 4.036 18.017 Z" />
            <Path d="M 10.036 18.016 C 9.659 18.015 9.315 17.802 9.146 17.466 C 8.899 16.974 9.096 16.376 9.586 16.126 L 17.796 12.016 L 9.586 7.906 C 8.875 7.61 8.751 6.656 9.363 6.188 C 9.689 5.939 10.134 5.915 10.486 6.126 L 20.486 11.126 C 21.171 11.477 21.219 12.438 20.573 12.856 C 20.545 12.874 20.516 12.891 20.486 12.906 L 10.486 17.906 C 10.348 17.98 10.193 18.018 10.036 18.016 Z" />
        </Svg>
    );
};
export default Right_Double_Chevron;
